<template>
    <v-container fluid fill-height grid-list-xs pa-0 :class="flexClass">
        <v-progress-linear :indeterminate="true" v-if="progressBarVisible" class="ma-0 pa-0 progress-top"></v-progress-linear>
        <v-layout row wrap>
            <v-flex xs12 md8>
                <v-card class="fill-height">

                    <v-toolbar card prominent dense>
                        <v-switch
                            class="mt-3"
                            v-model="scaleZ"
                            :label="$t('scaleDownByLength')"
                        ></v-switch>
                    </v-toolbar>
                    <v-container grid-list-md class="printable model-wrapper v-scrollable">
                        <v-layout wrap>
                            <v-sheet
                                class="d-flex model-container"
                                xs12 lg6
                                id="model_preview"
                                elevation="0"
                                ref="ModelPreview"
                            >
                                <three-d-log-view
                                    :model="model"
                                    :pattern="pattern"
                                    :zScale="scaleZ"
                                    :screenshot="true"
                                    ref="ThreeDModel"
                                />
                            </v-sheet>
                            <!--
                            <v-sheet
                                class="d-flex ml-4 mt-5"
                                xs12 lg6
                            >
                                <div v-if="this.selectedModel.name !== ''" class="mt-5">
                                    <p><b>{{ $t("name") }}:</b> {{ this.selectedPattern.name }}</p>
                                    <p><b>{{ $t("speciesAlt") }}:</b> {{ this.selectedPattern.speciesTranslated }}</p>
                                    <p><b>{{ $t("diameterU") }}:</b> {{ this.selectedPattern.Du }}</p>
                                    <p><b>{{ $t("createModifyDate") }}:</b> {{ this.selectedPattern.updatedAt }}</p>
                                </div>
                            </v-sheet>
                            -->
                        </v-layout>
                    </v-container>
                </v-card>
            </v-flex>
            <v-flex xs12 md4 pl-0 class="right-container">
                <v-tabs>
                    <v-tab><v-icon class="left-shifted-icon">mdi-transition</v-icon>&nbsp;{{ $t("log") }}</v-tab>
                    <v-tab><v-icon class="left-shifted-icon">mdi-bullseye</v-icon>&nbsp;{{ $t("pattern") }}</v-tab>

                    <v-tabs-items>
                        <v-tab-item>
                            <v-card flat class="fill-height">
                                <v-toolbar card prominent dense>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                flat
                                                v-on="on"
                                                @click="loadModels"
                                            >
                                                <v-icon>mdi-reload</v-icon>
                                            </v-btn>
                                        </template>

                                        <span>{{ $t("reload") }}</span>
                                    </v-tooltip>

                                    <upload-btn
                                        flat
                                        noTitleUpdate
                                        title=""
                                        :disabled="!acl.Create"
                                        v-if="models.length < modelsLimit"
                                        @file-update="onFileUpdate"
                                        ref="uploadButton"
                                    >
                                        <template slot="icon">
                                            <v-icon>mdi-upload-outline</v-icon>
                                            <div
                                                v-if="($store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp)"
                                            >
                                                {{ $t("import") }}
                                            </div>
                                        </template>
                                    </upload-btn>

                                    <v-btn
                                        flat
                                        v-if="models.length >= modelsLimit"
                                        @click="blockedImportClick"
                                    >
                                        <v-icon>mdi-upload-outline</v-icon>
                                        <div
                                            v-if="($store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp) || (!$store.getters.miniNavigationMenu && $vuetify.breakpoint.lgAndUp)"
                                        >
                                            {{ $t("import") }}
                                        </div>
                                    </v-btn>

                                    <v-btn
                                        flat
                                        v-if="false"
                                        :disabled="selectedModel !== null && (!selectedModel.updatedAt.length || !acl.Export)"
                                        @click="downloadModel"
                                    >
                                        <v-icon>mdi-download-outline</v-icon>
                                    </v-btn>

                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                flat
                                                v-on="on"
                                                :disabled="selectedModel !== null && (!selectedModel.updatedAt.length || !acl.Delete)"
                                                @click="onDeleteItemClick(selectedModel)"
                                            >
                                                <v-icon>mdi-delete-outline</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>{{ $t("delete") }}</span>
                                    </v-tooltip>
                                </v-toolbar>

                                <v-card-text>
                                    <v-container fluid fill-height grid-list-xs pa-0>
                                        <v-layout row wrap>
                                            <!--
                                            <v-flex xs12 md8 lg9 d-flex pa-0 style="overflow-x: auto;" class="v-scrollable">
                                            -->
                                            <v-flex xs12 d-flex pa-0 class="data-table__wrapper v-scrollable">
                                                <v-data-table
                                                    :headers="computedHeaders"
                                                    :items="filteredData"
                                                    :search="modelSearch"
                                                    :custom-sort="customSort"
                                                    hide-actions
                                                    class="dense-table"
                                                >
                                                    <template v-slot:items="props">
                                                        <tr
                                                            @click="loadModel(props.item.id)"
                                                            :class="{'grey darken-5': selectedModel !== null && props.item.id == selectedModel.id}"
                                                        >
                                                            <td class="text-xs-left">{{ props.item.fileName }}</td>
                                                            <td class="text-xs-right">{{ props.item.dTop }}</td>
                                                            <td class="text-xs-right">{{ props.item.l }}</td>
                                                            <td class="text-xs-right">{{ props.item.curvature }}</td>
                                                            <!--
                                                            <td class="justify-center layout px-0">
                                                            -->
                                                                <!--
                                                                <v-icon
                                                                    class="mr-2"
                                                                    @click="onEditItemClick(props.item)"
                                                                >
                                                                    edit
                                                                </v-icon>
                                                                -->
                                                                <!--
                                                                <v-icon
                                                                    @click="exportItem(props.item)"
                                                                >
                                                                    mdi-export
                                                                </v-icon>
                                                                -->
                                                                <!--
                                                                <v-icon
                                                                    @click="onDeleteItemClick(props.item)"
                                                                >
                                                                    delete
                                                                </v-icon>
                                                                -->
                                                            <!--
                                                            </td>
                                                            -->
                                                        </tr>
                                                    </template>
                                                    <!--
                                                    <template v-slot:no-results>
                                                        <v-alert :value="true" color="error" icon="warning">
                                                            {{ $t("youSearchFor") }}{{ patternSearch }}{{ $t("foundNoResults") }}.
                                                        </v-alert>
                                                    </template>
                                                    -->
                                                </v-data-table>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>

                        <v-tab-item>
                            <v-card flat class="fill-height">
                                <v-card-text>
                                    <v-container fluid fill-height grid-list-xs pa-0>
                                        <v-layout row wrap>
                                            <!--
                                            <v-flex xs12 md8 lg9 d-flex pa-0 style="overflow-x: auto;" class="v-scrollable">
                                            -->
                                            <v-flex
                                                d-flex
                                                xs12
                                                pa-0
                                                class="patterns-list v-scrollable"
                                                :class="{'no-pattern': pattern && Object.keys(pattern).length === 0 && Object.getPrototypeOf(pattern) === Object.prototype}"
                                            >
                                                <v-data-table
                                                    :headers="headersPattern"
                                                    :items="patterns"
                                                    :custom-sort="customSort"
                                                    hide-actions
                                                    class="dense-table"
                                                >
                                                    <template v-slot:items="props">
                                                        <tr
                                                            @click="showPattern(props.item)"
                                                            :class="{'grey darken-5': props.item.id == selectedPattern.id}"
                                                        >
                                                            <td class="text-xs-left">{{ props.item.speciesTranslated }}</td>
                                                            <td class="text-xs-center">{{ props.item.Du }}</td>
                                                            <td class="text-xs-left">{{ props.item.name }}</td>
                                                            <td class="text-xs-center">{{ props.item.updatedAt }}</td>
                                                        </tr>
                                                    </template>
                                                </v-data-table>
                                            </v-flex>
                                            <v-flex xs12 d-flex pa-0 pt-3 v-if="!(pattern && Object.keys(pattern).length === 0 && Object.getPrototypeOf(pattern) === Object.prototype)">
                                                <!--
                                                <div id="pattern-container" ref="Pattern">
                                                -->
                                                    <pattern-vue
                                                        :pattern="pattern"
                                                        :sizeNominal="true"
                                                        :falseCore="0"
                                                        :ellipseRatio="0"
                                                        :rotate="0"
                                                        :showDiameter="true"
                                                        :patternSolidBG="patternSolidBG"
                                                        :rotatePattern="rotatePattern"
                                                        sideSize="325"
                                                        ref="PatternVue"
                                                    />
                                                <!--
                                                </div>
                                                -->
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-card-text>
                            </v-card>
                        </v-tab-item>
                    </v-tabs-items>
                </v-tabs>
            </v-flex>

            <message-box    ref="MessageBox"/>
            <message-dialog ref="MessageDialog"/>

            <v-alert
                :value="alert !== ''"
                :type="alertType"
                transition="scale-transition"
                class="bottom-alert"
            >
                {{ alert }}
            </v-alert>
        </v-layout>
    </v-container>
</template>

<script>
    import MessageBox    from "@/components/dialogs/MessageBox";
    import MessageDialog from "@/components/dialogs/MessageDialog";
    import ThreeDLogView from "@/components/patterns/ThreeDLogView";
    import UploadButton  from "vuetify-upload-button";
    import PatternVue    from "@/components/patterns/PatternVue";

    export default {
        name: "ThreeDManagement",

        inject: ["theme"],

        components: {
            MessageBox,
            MessageDialog,
            ThreeDLogView,
            PatternVue,
            "upload-btn": UploadButton
            //UploadButton
        },

        data () {
            return {
                acl: {
                    Read:   false,
                    Create: false,
                    Modify: false,
                    Export: false,
                    Delete: false
                },
                alert: "",
                alertType: "success",

                breadCrumbs: [
                    { text: "Библиотека 3D", disabled: false }
                ],
                dataSavedAlert: false,
                dataSaveErrorAlert: false,
                modelDeletedAlert: false,
                modelDeleteErrorAlert: false,
                dialogWatcher: null,
                filterButtons: 0,
                filterPanels: [true, true],
                filters: {
                    timeStamp: []
                },
                headers: [
                    { text: "id",        value: "id",        align: "left", sortable: false },
                    { text: "fileName",  value: "fileName",  align: "left", sortable: true },
                    { text: "dTopShort", value: "dTop",      align: "right", sortable: true },
                    { text: "length",    value: "l",         align: "right", sortable: true },
                    { text: "curvature", value: "curvature", align: "right", sortable: true },
                    { text: "dataJSON",  value: "dataJSON",  align: "right", sortable: false }
                ],
                headersPattern: [
                    { text: "Порода",                  value: "species",   align: "left",   sortable: true },
                    { text: "Диаметр",                 value: "Du",        align: "left",   sortable: true },
                    { text: "Имя",                     value: "name",      align: "left",   sortable: true },
                    { text: "Дата создания/изменения", value: "modDate",   align: "center", sortable: true }
                ],
                hideIDs: true,
                model: {},
                models: [],
                modelsLimit: 1,
                modelSearch: "",
                pattern: {},
                patterns: [],
                scaleZ: false,
                selectedModel: {
                    timeStamp: "",
                    updatedAt: "",
                    updatedAtTimestamp: ""
                },
                selectedPattern: {
                    name: "",
                    species: "",
                    Du: 0,
                    updatedAt: ""
                },

                loading: {
                    model:       false,
                    models:      false,
                    uploadModel: false,
                    patterns:    false
                },

                patternSolidBG: false,
                rotatePattern:  false,
            }
        },

        computed: {
            computedHeaders () {
                if (this.hideIDs) {
                    return this.headers.filter(
                        header => header.text !== "id" &&
                        header.text !== "timeStamp" &&
                        header.text !== "dataJSON"
                    );
                }

                return this.headers;
            },

            filteredData () {
                return this.models.filter(data => {
                    return Object.keys(this.filters).every(filter => {
                        return this.filters[filter].length < 1 || this.filters[filter].includes(data[filter])
                    })
                })
            },

            flexClass () {
                return {
                    //lgUp: this.$vuetify.breakpoint.lgAndUp,
                    "md-up": this.$vuetify.breakpoint.mdAndUp
                }
            },

            progressBarVisible () {
                return this.loading.model || this.loading.models || this.loading.uploadModel || this.loading.patterns;
            }
        },

        mounted () {
            if (!this.$store.getters.user.loggedIn) {
                if (!this.$noRedirect.includes(this.$router.currentRoute.path)) {
                    this.$router.push("/home");
                }
            }

            this.applyLocale();
            this.loadModels();
            this.loadPatterns();

            this.$root.$on("localeChanged", () => { this.applyLocale(); });

            this.scaleZ = localStorage.threeDModelScaleZ ? JSON.parse(localStorage.threeDModelScaleZ) : false;

            if (localStorage.threeDModelId) {
                this.loadModel(localStorage.threeDModelId)
            }

            if (this.$store.getters.user.acl) {
                this.$store.getters.user.acl.forEach((aclRecord) => {
                    if (aclRecord.Module.Name == "threeDModels") {
                        this.acl = aclRecord;
                    }
                });
            }

            this.modelsLimit = this.$store.getters.subscription.limits.maxModels
                ? this.$store.getters.subscription.limits.maxModels
                : 1;

            let user = this.$store.getters.user;

            this.patternSolidBG = user.settings.patternSolidBG;
            this.rotatePattern  = user.settings.rotatePattern;
        },

        beforeDestroy() {
            this.$refs.ThreeDModel.cleanup();
        },

        watch: {
            alert: function (val) {
                let component = this;
                if (val !== "") {
                    setTimeout(() => {
                        component.alert = "";
                    }, 3000);
                }
            },

            dataSavedAlert: function (val) {
                if (val) {
                    setTimeout(() => this.dataSavedAlert = false, 1500);
                }
            },

            scaleZ: function (val) { localStorage.threeDModelScaleZ = val; }
        },

        methods: {
            /**
             * Применение локали
             */
            applyLocale () {
                this.headers = [
                    { text: "id",                 value: "id",        align: "left",  sortable: false },
                    { text: this.$t("fileName"),  value: "fileName",  align: "left",  sortable: true },
                    { text: this.$t("dTopShort"), value: "dTop",      align: "right", sortable: true },
                    { text: this.$t("length"),    value: "l",         align: "right", sortable: true },
                    { text: this.$t("curvature"), value: "curvature", align: "right", sortable: false },
                    { text: "dataJSON",           value: "dataJSON",  align: "left",  sortable: false } //,
                    //{ text: this.$t("createModifyDate"), value: "modDate",   align: "left",   sortable: true } //,
                    //{ text: this.$t("action"),           value: "action",    align: "center", sortable: false }
                ];

                this.breadCrumbs = [
                    { text: this.$t("threeDLibrary"), disabled: false }
                ];
            },

            /**
             * Сортировка таблицы
             *
             * @param {array}   items  Сортируемый список
             * @param {string}  index  Столбец сортировки
             * @param {boolean} isDesc Флаг сортировки по убыванию
             */
            customSort(items, index, isDesc) {
                items.sort((a, b) => {
                    if (index === "modDate") {
                        if (!isDesc) {
                            return a.updatedAtTimestamp < b.updatedAtTimestamp ? -1 : 1;
                        } else {
                            return a.updatedAtTimestamp > b.updatedAtTimestamp ? -1 : 1;
                        }
                    } else {
                        if (!isDesc) {
                            return a[index] < b[index] ? -1 : 1;
                        } else {
                            return a[index] > b[index] ? -1 : 1;
                        }
                    }
                });
                return items;
            },

            /**
             * Отображение сообщения о блокировании создания
             */
            blockedCreateClick () {
                if (this.models.length >= this.modelsLimit) {
                    this.showMessageBox(this.$t("attention"), this.$t("createModelsLimitReachedMessage"));
                }
            },

            /**
             * Отображение сообщения о блокировании загрузки
             */
            blockedImportClick () {
                if (this.models.length >= this.modelsLimit) {
                    this.showMessageBox(this.$t("attention"), this.$t("uploadModelsLimitReachedMessage"));
                }
            },

            /**
             * Удаление постава
             *
             * @param {object} item Постав
             */
            deleteItem (item) {
                // Удаление наблюдателя если установлен
                if (this.dialogWatcher !== null) {
                    this.dialogWatcher();
                }

                this.axios({
                    method: "delete",
                    url: `${this.$config.apiURL}3dmodels/${item.id}/`,
                    withCredentials: true
                }).then(() => {
                    this.alertType = "success";
                    this.alert     = this.$t("modelDeleted");
                    this.loadModels();
                }).catch(err => {
                    this.axios({
                        method: "post",
                        url: `${this.$config.apiURL}syslog/`,
                        data: {
                            messageType: "error",
                            messageText: `ThreeDManagement.vue -> deleteItem: ${JSON.stringify(err)}`
                        },
                        withCredentials: true
                    }).then(response => {
                        if (response.data.status == "failure") {
                            this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                        }
                    }).catch(error => {
                        if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                        }
                    });

                    if (err.response && err.response.status == 401) {
                        this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { window.location.reload(); }
                        );
                    } else if (err.response && err.response.status == 402) {
                        this.showMessageBox(this.$t("error"), this.$t("cantDeleteModel") + ". " + this.$t("subscriptionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { this.$emit("doLogout", true); }
                        );
                    } else if (err.response && err.response.status == 403 && typeof err.response.data !== "object" && err.response.data.trim() == "Access denied. Session id mismatch") {
                        this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                    } else if (err.response && err.response.status == 403) {
                        this.showMessageBox(this.$t("error"), this.$t("cantDeleteModel") + ". " + this.$t("accessDenied"));
                    } else {
                        this.alertType = "error";
                        this.alert     = this.$t("modelDeleteError");
                    }
                });
            },

            /**
             * Запуск выгрузки текущей модели
             */
            downloadModel () {
                this.$debug.log("downloadModel");
            },

            /**
             * Загрузка модели
             *
             * @param {number} id Идентификатор модели
             */
            loadModel (id) {
                this.loading.model = true;

                this.axios.get(`${this.$config.apiURL}3dmodels/${id}/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            this.selectedModel = response.data.model;
                            this.model = JSON.parse(response.data.model.DataJSON);
                        }

                        localStorage.threeDModelId = id;

                        this.loading.model = false;
                    })
                    .catch(err => {
                        this.loading.model = false;

                        this.axios({
                            method: "post",
                            url: `${this.$config.apiURL}syslog/`,
                            data: {
                                messageType: "error",
                                messageText: `ThreeDManagement.vue -> loadModel: ${JSON.stringify(err)}`
                            },
                            withCredentials: true
                        }).then(response => {
                            if (response.data.status == "failure") {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        }).catch(error => {
                            if (error.response && error.response.status == 402) {
                                this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                            } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                            } else if (error.response && error.response.status == 403) {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        });

                        if (err.response && err.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (err.response && err.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoad3DModelData") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (err.response && err.response.status == 403 && typeof err.response.data !== "object" && err.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (err.response && err.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoad3DModelData") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoad3DModelData"));
                        }
                    });
            },

            /**
             * Загрузка моделей
             */
            loadModels () {
                this.loading.models = true;

                this.axios.get(`${this.$config.apiURL}3dmodels/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let modelsInfo = response.data.models

                            this.models = [];

                            modelsInfo.forEach((modelInfo) => {
                                let updatedTimestamp = new Date(modelInfo.updatedAt);
                                let dataParsed       = JSON.parse(modelInfo.DataJSON);

                                this.models.push({
                                    id:        modelInfo.id,
                                    fileName:  modelInfo.FileName,
                                    dTop:      dataParsed.head.TopD,
                                    l:         dataParsed.head.L,
                                    curvature: (dataParsed.head.Curvature * .1).toFixed(1),
                                    timeStamp: (new Date(modelInfo.TimeStamp)).toLocaleString(),
                                    //dataJSON:  modelInfo.DataJSON,
                                    updatedAt: updatedTimestamp.toLocaleString(),
                                    updatedAtTimestamp: Date.parse(updatedTimestamp),
                                });
                            });
                        }

                        this.loading.models = false;
                    })
                    .catch(err => {
                        this.loading.models = false;

                        this.axios({
                            method: "post",
                            url: `${this.$config.apiURL}syslog/`,
                            data: {
                                messageType: "error",
                                messageText: `ThreeDManagement.vue -> loadModels: ${JSON.stringify(err)}`
                            },
                            withCredentials: true
                        }).then(response => {
                            if (response.data.status == "failure") {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        }).catch(error => {
                            if (error.response && error.response.status == 402) {
                                this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                            } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                            } else if (error.response && error.response.status == 403) {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        });

                        if (err.response && err.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (err.response && err.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoad3DModelsData") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (err.response && err.response.status == 403 && typeof err.response.data !== "object" && err.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (err.response && err.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoad3DModelsData") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoad3DModelsData"));
                        }
                    });
            },

            /**
             * Загрузка поставов
             */
            loadPatterns () {
                this.loading.patterns = true;

                this.axios.get(`${this.$config.apiURL}patterns/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let patternsInfo = response.data.patterns;

                            this.patterns    = [];

                            patternsInfo.forEach((patternInfo) => {
                                let updatedTimestamp = new Date(patternInfo.updatedAt);

                                this.patterns.push({
                                    id:        patternInfo.id,
                                    species:   patternInfo.Species.Name,
                                    speciesTranslated: this.$t(patternInfo.Species.Name),
                                    name:      patternInfo.Name,
                                    Du:        patternInfo.Du,
                                    Dmin:      patternInfo.Dmin,
                                    Dmax:      patternInfo.Dmax,
                                    DLimitMin: patternInfo.DLimitMin,
                                    DLimitMax: patternInfo.DLimitMax,
                                    dataJSON:  patternInfo.DataJSON,
                                    updatedAt: updatedTimestamp.toLocaleString(),
                                    updatedAtTimestamp: Date.parse(updatedTimestamp),
                                    //visible:    patternInfo.visible
                                });

                            });
                        }

                        this.loading.patterns = false;
                    })
                    .catch(err => {
                        this.loading.patterns = false;

                        this.axios({
                            method: "post",
                            url: `${this.$config.apiURL}syslog/`,
                            data: {
                                messageType: "error",
                                messageText: `ThreeDManagement.vue -> loadPatterns: ${JSON.stringify(err)}`
                            },
                            withCredentials: true
                        }).then(response => {
                            if (response.data.status == "failure") {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        }).catch(error => {
                            if (error.response && error.response.status == 402) {
                                this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                            } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                            } else if (error.response && error.response.status == 403) {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        });

                        if (err.response && err.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (err.response && err.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadPatternsData") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (err.response && err.response.status == 403 && typeof err.response.data !== "object" && err.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (err.response && err.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadPatternsData") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadPatternsData"));
                        }
                    });
            },

            /**
             * Обработчик нажатия кнопки удаления постава
             *
             * @param {object} item Постав
             */
            onDeleteItemClick (item) {
                /* Отслеживание ответа в диалоге "Да/Нет" */
                this.dialogWatcher = this.$watch(
                    "$refs.MessageDialog.answer",
                    (val) => {
                        if (val) { this.deleteItem(item); }
                    }
                );

                this.$refs.MessageDialog.title       = this.$t("delete");
                this.$refs.MessageDialog.messageText = this.$t("confirm3DModelDelete") + " (" + item.fileName + ")";
                this.$refs.MessageDialog.dialog      = true;
            },

            /**
             * Обработчик выбора пользователем файла для загрузки
             *
             * @param {object} file Информация о файле
             */
            onFileUpdate (file) {
                if (file !== undefined) {
                    let comp     = this;
                    let formData = new FormData();

                    formData.append("file", file);

                    this.loading.uploadModel = true;

                    // Загрузить файл
                    this.axios({
                        method: "post",
                        headers: {
                            "Content-Type": "multipart/form-data"
                        },
                        url: `${this.$config.apiURL}3dmodels/upload/`,
                        data: formData,
                        withCredentials: true
                    }).then(response => {
                        if (response.status == 200 ) {
                            if (response.data.status == "attention" && response.data.message == "subscriptionLimitReached") {
                                this.showMessageBox(this.$t("attention"), this.$t("uploadModelsLimitReachedMessage"));
                            } else if (response.data.status == "attention") {
                                this.showMessageBox(this.$t("error"), this.$t("cantUploadModel"));
                            } else {
                                comp.alertType = "success";
                                comp.alert     = comp.$t("dataSaved");
                                comp.loadModels();
                            }
                        }

                        this.loading.uploadModel = false;
                    }).catch(err => {
                        this.loading.uploadModel = false;

                        this.axios({
                            method: "post",
                            url: `${this.$config.apiURL}syslog/`,
                            data: {
                                messageType: "error",
                                messageText: `ThreeDManagement.vue -> onFileUpdate: ${JSON.stringify(err)}`
                            },
                            withCredentials: true
                        }).then(response => {
                            if (response.data.status == "failure") {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        }).catch(error => {
                            if (error.response && error.response.status == 402) {
                                this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                            } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                                this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                            } else if (error.response && error.response.status == 403) {
                                this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                            }
                        });

                        if (err.response && err.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (err.response && err.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantUploadFile") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (err.response && err.response.status == 403 && typeof err.response.data !== "object" && err.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (err.response && err.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantUploadFile") + ". " + this.$t("accessDenied"));
                        } else if (err.response && err.response.status == 413) {
                            this.showMessageBox(this.$t("error"), this.$t("cantUploadFile") + ". " + this.$t("fileTooLarge"));
                        } else if (err.response && err.response.status == 415) {
                            this.showMessageBox(this.$t("error"), this.$t("fileParsingError"));
                        } else {
                            comp.alertType = "error";
                            comp.alert     = comp.$t("dataSaveError");
                        }
                    });

                    this.$refs.uploadButton.clear();
                }
            },

            /**
             * Сброс фильтров
             */
            resetFilters () {
                this.filters.Du = [];
                this.filters.speciesTranslated = [];
            },

            /*
            exportItem (item) {
                window.open(${this.$config.apiURL} + "3dmodels/download/" + item.id, "_blank");
            },
            */

           /**
             * Отображение постава
             *
             * @param {object} data Постав
             */
            showPattern (data) {
                this.selectedPattern = data;
                //localStorage.patternsLibCurrent = JSON.stringify(this.selectedPattern); //data);
                this.pattern = JSON.parse(data.dataJSON); //data;
            },

            /**
             * Отображение сообщения
             *
             * @param {string} title       Заголовок
             * @param {string} messageText Текст сообщения
             */
            showMessageBox (title, messageText) {
                this.$refs.MessageBox.title       = title;
                this.$refs.MessageBox.messageText = messageText;
                this.$refs.MessageBox.dialog      = true;
            }
        }
    }
</script>

<style lang="sass" scoped>
    $pattern-height: 325px

    #app.theme
        &--light .upload-btn .v-btn--disabled .v-btn__content
            color: rgba(0,0,0,0.26) !important
        &--dark .upload-btn .v-btn--disabled .v-btn__content
            color: rgba(255,255,255,0.3) !important

    .bottom-alert
        position: fixed
        bottom: 0
        right: 0
        z-index: 999

    .model-container
        box-sizing: border-box
        border: 1px solid #aaa
        display: inline-block
        padding: 8px
        width: 100%
        height: calc(100vh - 191px)
        margin: 0 auto

    .right-container
        .v-window
            height: calc(100vh - 115px)
            .v-window__container,
            .v-window-item
                height: 100%
        .v-card.fill-height
            height: calc(100vh - 115px)
            .v-card__text
                padding-bottom: 0
        .data-table__wrapper.v-scrollable
            overflow-x: auto
            height: calc(100vh - 185px) !important

        .patterns-list
            overflow-x: auto
            height: calc(100vh - 158px - $pattern-height) !important
            &.no-pattern
                height: calc(100vh - 130px) !important

</style>
